import {
	CircularProgress,
	FormControl,
	InputLabel,
	MenuItem,
	Select,
} from "@mui/material";
import { isNil } from "lodash-es";
import React from "react";
import { searchAssets } from "../../../asset/components/TreeAsset";

interface AssetSelectorProps {
	value: number | null;
	onChange: (value: number | null) => void;
	disabled?: boolean;
}

export const AssetSelector: React.FC<AssetSelectorProps> = ({
	value,
	onChange,
	disabled = false,
}) => {
	const { data: assets, isLoading } = searchAssets();

	const areasList = React.useMemo(
		() => assets?.filter((a) => a.CanBeDefaultAsset) ?? [],
		[assets],
	);

	const hasAssets = areasList.length > 0;

	const handleChange = (event: any) => {
		const selectedValue = event.target.value;
		if (selectedValue === "" || selectedValue === 0) {
			onChange(null);
		} else {
			onChange(Number(selectedValue));
		}
	};

	if (isLoading) {
		return (
			<FormControl variant="outlined" fullWidth size="small" disabled>
				<InputLabel>Default Asset</InputLabel>
				<Select value="" label="Default Asset">
					<MenuItem value="">
						<CircularProgress size={20} />
					</MenuItem>
				</Select>
			</FormControl>
		);
	}

	return (
		<FormControl variant="outlined" fullWidth size="small" disabled={disabled}>
			<InputLabel>Default Asset</InputLabel>
			<Select
				value={isNil(value) ? "" : value}
				onChange={handleChange}
				label="Default Asset"
			>
				<MenuItem value="">
					<em>None</em>
				</MenuItem>
				{hasAssets &&
					areasList.map((area) => (
						<MenuItem key={area?.AssetId} value={area?.AssetId}>
							{area?.AssetName}
						</MenuItem>
					))}
			</Select>
		</FormControl>
	);
};
